import React, { useState } from "react";
import { Link } from "react-router-dom";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  // Inline CSS
  const headerStyle = {
    width: "100%",
    background: "#bce233",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
    position: "sticky",
    top: 0,
    zIndex: 999,
  };

  const logoStyle = {
    width: "177px",
    height: "70px",
  };

  const menuWrapperStyle = {
    display: menuOpen ? "block" : "none",
    position: "absolute",
    top: "100%",
    left: 0,
    width: "100%",
    background: "#fff",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
  };

  const ulStyle = {
    listStyle: "none",
    margin: 0,
    padding: 0,
  };

  const liStyle = {
    padding: "15px 20px",
    borderBottom: "1px solid #eee",
  };

  const hamburgerStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "25px",
    height: "20px",
    cursor: "pointer",
    background: "transparent",
    border: "none",
  };

  const barStyle = {
    height: "3px",
    width: "100%",
    backgroundColor: "#333",
    borderRadius: "2px",
    transition: "all 0.3s ease",
  };

  const searchPopupStyle = {
    display: "none", // Optional, can add toggle later
  };

  return (
    <div>
      {/* Header Section Start */}
      <header style={headerStyle}>
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 20px",
            position: "relative",
          }}
        >
          {/* Logo */}
          <div className="logo">
            <Link to="/">
              <img src="assets/img/logo/logo.png" alt="logo-img" style={logoStyle} />
            </Link>
          </div>

          {/* Navigation Menu */}
          <div style={menuWrapperStyle}>
            <ul style={ulStyle}>
              <li style={liStyle}>
                <Link to="/">Home</Link>
              </li>
              <li style={liStyle}>
                <Link to="/about">About Us</Link>
              </li>
              <li style={liStyle}>
                <Link to="/blogdetail">Blog</Link>
              </li>
              <li style={liStyle}>
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>
          </div>

          {/* Hamburger Button */}
          <button
            style={hamburgerStyle}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle Menu"
          >
            <span
              style={{
                ...barStyle,
                transform: menuOpen ? "rotate(45deg) translate(5px,5px)" : "none",
              }}
            ></span>
            <span
              style={{
                ...barStyle,
                opacity: menuOpen ? 0 : 1,
              }}
            ></span>
            <span
              style={{
                ...barStyle,
                transform: menuOpen ? "rotate(-45deg) translate(5px,-5px)" : "none",
              }}
            ></span>
          </button>
        </div>
      </header>

      {/* Search Popup (Optional) */}
      <div style={searchPopupStyle}>
        <div
          onClick={() => setMenuOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        ></div>
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "#fff",
            padding: "20px",
            borderRadius: "5px",
          }}
        >
          <form>
            <input
              type="text"
              placeholder="Search Here..."
              style={{ padding: "10px", width: "200px", marginRight: "10px" }}
            />
            <button type="submit" style={{ padding: "10px" }}>
              🔍
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Header;
